import { render, staticRenderFns } from "./CustomRadioBorder.vue?vue&type=template&id=30c9253b&scoped=true"
import script from "./CustomRadioBorder.vue?vue&type=script&lang=js"
export * from "./CustomRadioBorder.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioBorder.vue?vue&type=style&index=0&id=30c9253b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9253b",
  null
  
)

export default component.exports